<div class="flex justify-between items-center">
    <h2 mat-dialog-title class="text-lg font-bold mb-1">{{data.name}}</h2>
    <!-- <button mat-button (click)="exportChart()" class="flex items-center" matTooltip="Descargar Reporte"> -->
        <mat-icon color="primary" svgIcon="excel" (click)="exportChart()" matTooltip="Descargar Reporte"
            class="pointer-icon flex items-center mr-5"></mat-icon>
    <!-- </button> -->
</div>
<mat-dialog-content class="modal-content">
    <div id="chart" class="chart-container"></div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="modal-actions">
    <button mat-button mat-dialog-close class="close-button">Cerrar</button>
</mat-dialog-actions>